import React from 'react'
import { formatInTimeZone, getTimezoneData } from '@chilipiper/date-time'

type Props = {
  date: { end: string; start: string }
  timezone: string
}

export const DisplayDate = ({ date, timezone }: Props) => {
  return (
    <>
      {formatInTimeZone(new Date(date.start), timezone, 'EEEE, MMM d,')}
      <br />
      {formatInTimeZone(new Date(date.start), timezone, 'h:mm a')} -{' '}
      {formatInTimeZone(new Date(date.end), timezone, 'h:mm a')}{' '}
      {getTimezoneData(timezone, new Date(date.start))?.abbreviation}
    </>
  )
}
